// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HistoryCard {
  padding: 1.5rem 1rem;
  background: linear-gradient(90deg, #f0fdf6 0%, #f9fefc 100%);
  border-radius: 0.4rem;
  border: 1px solid #e3e8ef;
}
.HistoryCard .icon-container.icon-bg-success {
  background: #dcf9e8;
  padding: 0.4rem;
}
.HistoryCard i.sv {
  font-size: 1.5rem;
}
.HistoryCard > .HistoryCard-Body {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  border-left: 2px solid #b8f1d2;
  margin-left: 1rem;
  padding-left: 1.8rem;
}
.HistoryCard > .HistoryCard-Body .RouteList {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.HistoryCard > .HistoryCard-Body .RouteList > .RouteCard {
  background: #f9fefb;
}`, "",{"version":3,"sources":["webpack://./src/features/DriveTimeTool/components/HistoryCard/styles.scss"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,4DAAA;EACA,qBAAA;EACA,yBAAA;AACF;AACE;EACE,mBAAA;EACA,eAAA;AACJ;AACE;EACE,iBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,8BAAA;EACA,iBAAA;EACA,oBAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AACN;AACM;EACE,mBAAA;AACR","sourcesContent":[".HistoryCard {\n  padding: 1.5rem 1rem;\n  background: linear-gradient(90deg, #f0fdf6 0%, #f9fefc 100%);\n  border-radius: 0.4rem;\n  border: 1px solid #e3e8ef;\n\n  .icon-container.icon-bg-success {\n    background: #dcf9e8;\n    padding: 0.4rem;\n  }\n  i.sv {\n    font-size: 1.5rem;\n  }\n\n  > .HistoryCard-Body {\n    display: flex;\n    flex-direction: column;\n    gap: 2rem;\n    border-left: 2px solid #b8f1d2;\n    margin-left: 1rem;\n    padding-left: 1.8rem;\n    .RouteList {\n      display: flex;\n      flex-direction: column;\n      gap: 1rem;\n\n      > .RouteCard {\n        background: #f9fefb;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
